import React from 'react';
import { contactInfo } from '../mockData';
import { MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-red-700 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <p className="text-sm md:text-base">
            Copyrights © {currentYear} Swaarnim Book Of Records. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
